import classNames from "classnames";
import React from "react";
import styles from "./Separator.module.scss";

const Separator = (props) => {
  return (
    <div
      className={classNames(
        styles.separator,
        props.vertical && styles.vertical,
        props.className,
      )}
    />
  );
};

export default Separator;
